module.exports = __webpack_public_path__ + "media/src/images/apple-icon-152x152-5060eed6fbf3a78b3a01f2b214fe2ad2.png";